import React, { useState, useEffect, useRef } from "react";
import Expenses from "../../components/expensecard";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../components/Loader/Loader";
import { BiChevronLeft, BiChevronRight, BiSearch, BiX } from "react-icons/bi";
import { expensePagePosition, inventoryRequest } from "../../store/actions/dealerInventoryAction";
import { dateTime_MWORD, dateTime_MWORD_AMPM } from "../../utils/dateFormat";
import BuyCards from "../../components/buyCard";
import { useQuery } from "../../utils/useQuery";

const ExpenseInvList = ({ data, viewExpense, addExpense, modalOpen }) => {
  const queryParams = useQuery();
  const dealerInvObj = useSelector((state) => state.dealerInventoryReducer);
  const { loading, currentPagePosition } = dealerInvObj;
  const filterExpenseObj = useSelector((state) => state.expenseFilterReducer);
  const { filteredData, finalOption } = filterExpenseObj;

  const userid = queryParams.get("userid") || dealerInvObj?.reqInv?.user_id;

  const [searchTerm, setSearchTerm] = useState("");
  const isFirstRender = useRef(true);

  const itemsPerPage = 10;
  const cardStatus = ["Inward", "Live", "Live", "Live", "Sold"];
  const cardStatusColor = [
    "#652278",
    "#64B161",
    "#64B161",
    "#64B161",
    "#DC3F43",
  ];
  const dispatch = useDispatch();

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const timer = setTimeout(() => {
      dispatch(expensePagePosition({ currentPagePosition: 1 }));
      if (userid) {
        if (searchTerm.trim() !== "") {
          dispatch(
            inventoryRequest({
              reqInv: { user_id: userid, chassis_number: searchTerm.trim() },
            })
          );
        } else {
          dispatch(inventoryRequest({ reqInv: { user_id: userid } }));
        }
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm, userid, dispatch]);

  const handleSearchSubmit = (e) => {
    if (e) e.preventDefault();
    dispatch(expensePagePosition({ currentPagePosition: 1 }));
    if (userid) {
      if (searchTerm.trim() !== "") {
        dispatch(
          inventoryRequest({
            reqInv: { user_id: userid, chassis_number: searchTerm.trim() },
          })
        );
      } else {
        dispatch(inventoryRequest({ reqInv: { user_id: userid } }));
      }
    }
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    dispatch(expensePagePosition({ currentPagePosition: 1 }));
    if (userid) {
      dispatch(inventoryRequest({ reqInv: { user_id: userid } }));
    }
  };

  const displayData = data?.filter((item) => {
    if (!searchTerm || searchTerm.trim() === "") return true;
    const term = searchTerm.trim().toLowerCase();
    const chassis = item?.chassis_number?.toLowerCase() || "";
    const brand = item?.brand?.toLowerCase() || "";
    const model = item?.model?.toLowerCase() || "";
    const regNo =
      (
        item?.additional_featureInfo?.["Registration (RTO) No"] ||
        item?.additional_featureInfo?.["Registration (RTO) No."]
      )?.toLowerCase() || "";
    return (
      chassis.includes(term) ||
      brand.includes(term) ||
      model.includes(term) ||
      regNo.includes(term)
    );
  });

  const totalPages = Math.ceil((displayData?.length || 0) / itemsPerPage) || 1;

  const currentItems = displayData
    ?.sort((a, b) => b.tractor_id - a.tractor_id)
    ?.slice(
      (currentPagePosition - 1) * itemsPerPage,
      currentPagePosition * itemsPerPage
    );

  const handlePageChange = (newPage) => {
    if (displayData?.length > itemsPerPage) {
      dispatch(expensePagePosition({ currentPagePosition: newPage }));
    }
  };

  return (
    <Expenses>
      <Expenses.ListTitle
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        All Tractors
        <BuyCards.FilterButton
          style={{ color: "#F26F21", fontSize: "16px" }}
          onClick={() => modalOpen()}
        >
          <BuyCards.ButtonIcon
            src="./assets/filter_list_black.svg"
            alt="filter icon"
            style={{ height: "24px" }}
          />
          Filter
        </BuyCards.FilterButton>
      </Expenses.ListTitle>

      <Expenses.SearchBy>
        <form
          onSubmit={handleSearchSubmit}
          style={{ display: "flex", width: "100%", alignItems: "center" }}
        >
          <div
            style={{
              position: "relative",
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          >
            <BiSearch
              style={{
                position: "absolute",
                left: "12px",
                color: "#666",
                fontSize: "20px",
              }}
            />
            <input
              type="text"
              placeholder="Search by Chassis Number..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: "100%",
                padding: "10px 105px 10px 38px",
                borderRadius: "8px",
                border: "1px solid #ccc",
                fontSize: "14px",
                outline: "none",
              }}
            />
            {searchTerm && (
              <BiX
                onClick={handleClearSearch}
                style={{
                  position: "absolute",
                  right: "75px",
                  color: "#999",
                  fontSize: "22px",
                  cursor: "pointer",
                }}
              />
            )}
            <button
              type="submit"
              style={{
                position: "absolute",
                right: "4px",
                background: "#652278",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                padding: "6px 14px",
                fontSize: "13px",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              Search
            </button>
          </div>
        </form>
      </Expenses.SearchBy>

      <BuyCards.FilterContent>
        <BuyCards.Message>
          {filteredData?.length > 0
            ? `After filter showing ${filteredData?.length} ${finalOption ? finalOption : ""} ${filteredData?.length < 2 ? "tractor" : "tractors"}.`
            : `Showing all ${displayData?.length || 0} ${displayData?.length < 2 ? "tractor" : "tractors"}.`}
        </BuyCards.Message>
      </BuyCards.FilterContent>
      <Expenses.Pagination>
        <Expenses.PageCountContainer>
          <Expenses.PageCountLabel>
            &nbsp;<b>Total Pages: {totalPages}</b>
          </Expenses.PageCountLabel>
          <Expenses.PageButton
            disabled={currentPagePosition === 1}
            onClick={() => handlePageChange(currentPagePosition - 1)}
          >
            <BiChevronLeft style={{ height: "30px", width: "30px" }} />
          </Expenses.PageButton>
          <b>{currentPagePosition}</b>
          <Expenses.PageButton
            disabled={currentPagePosition === totalPages}
            onClick={() => handlePageChange(currentPagePosition + 1)}
            style={{
              backgroundColor: "white",
              border: "none",
              height: "30px",
              width: "30px",
              marginLeft: "5px",
            }}
          >
            <BiChevronRight style={{ height: "30px", width: "30px" }} />
          </Expenses.PageButton>
        </Expenses.PageCountContainer>
      </Expenses.Pagination>
      {loading ? (
        <Loader />
      ) : displayData?.length === 0 ? (
        <div
          style={{
            textAlign: "center",
            padding: "30px 10px",
            color: "#666",
            fontSize: "14px",
          }}
        >
          No tractors found matching your search.
        </div>
      ) : (
        <Expenses.Cards>
          {currentItems?.map((item, index) => (
            <Expenses.Card onClick={() => viewExpense(item)} key={index}>
              <Expenses.CardDetails>
                <Expenses.Header>
                  <Expenses.CardLabel
                    style={{
                      backgroundColor: cardStatusColor[item?.["status"]],
                    }}
                  >
                    {cardStatus[item?.["status"]]}
                  </Expenses.CardLabel>
                  <span
                    style={{
                      fontSize: "11px",
                      color: "#666",
                      marginLeft: "8px",
                    }}
                  >
                    {" "}
                    {dateTime_MWORD(item?.["created_at"])}
                  </span>
                  <Expenses.RTONumber>
                    {item?.additional_featureInfo?.["Registration (RTO) No"]}
                  </Expenses.RTONumber>
                </Expenses.Header>
                <Expenses.CardMain>
                  <Expenses.CardTitle>
                    {item[`buying_year`]} {item[`brand`]} {item[`model`]}
                  </Expenses.CardTitle>
                  <Expenses.ChassisNumber>
                    Chassis No. {item?.chassis_number}
                  </Expenses.ChassisNumber>
                  <Expenses.PriceContainer>
                    <Expenses.PriceLabel>Price:</Expenses.PriceLabel>
                    <Expenses.Price>₹ {item?.max_price}</Expenses.Price>
                  </Expenses.PriceContainer>
                </Expenses.CardMain>
                <Expenses.Bottom>
                  <Expenses.Time>
                    {item?.expense_data?.expense_last_updated_at &&
                      `Last Updated: ${dateTime_MWORD_AMPM(item?.expense_data?.expense_last_updated_at)}`}
                  </Expenses.Time>
                  {(!item?.expense_data?.sourcing ||
                    !item?.expense_data?.liquidation ||
                    !item?.expense_data?.operation) && (
                    <Expenses.Button onClick={(e) => addExpense(e, item)}>
                      <img src="../assets/expense/add.svg" alt="Add icon" />
                      EXPENSE
                    </Expenses.Button>
                  )}
                </Expenses.Bottom>
              </Expenses.CardDetails>
            </Expenses.Card>
          ))}
        </Expenses.Cards>
      )}
    </Expenses>
  );
};

export default ExpenseInvList;
